export default __webpack_public_path__ + "static/media/KOD0081-min.f60fb37b.webp";